export const accountNumberReg = {
  requiredMessage: '계좌번호를 입력해주세요.',
  patternMessage: '올바른 계좌번호를 입력해주세요.',
  regExp: /^\d{10,14}$/,
  minLength: 1
};
